module.exports = __webpack_public_path__ + "static/media/sven.63881527.jpg";